import { IoIosArrowRoundDown } from 'react-icons/io'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const NewsPageContainer = styled.div`
	width: 95%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	max-width: 1240px;
	padding: 200px 5px 0px 5px;

	@media (max-width: 1200px) {
		max-width: 90%;
	}
`

export const NewsPageTitle = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 500;
	font-size: 48px;
	letter-spacing: 0.03em;
	text-transform: uppercase;
	background: linear-gradient(227deg, #373839 0%, #01b75c 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	max-width: 250px;

	@media (max-width: 630px) {
		font-size: 36px;
	}
`

export const NewsPageContent = styled.div<{ isFiltersOpen?: boolean }>`
	margin-top: 35px;
`

export const NewsCardsList = styled.div<{ isFiltersOpen?: boolean }>`
	position: relative;
	display: ${({ isFiltersOpen }) => (isFiltersOpen ? 'none' : 'grid')};
	gap: 10px;
	grid-template-columns: repeat(3, minmax(300px, 370px));
	grid-auto-rows: auto;
	min-height: 780px;
	padding: 30px 5px 50px 5px;
	width: 100%;
	row-gap: 30px;
	gap: 55px;
	box-sizing: border-box;

	@media (max-width: 1200px) {
		grid-template-columns: repeat(3, minmax(200px, 300px));
		justify-content: center;
		gap: 30px;
	}

	@media (max-width: 768px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 630px) {
		grid-template-columns: repeat(auto-fit, minmax(200px, 365px));
	}
`

export const NewsCardItem = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 100%;
	flex: 1;
	min-width: 230px;
	box-sizing: border-box;
`

export const CardImg = styled.img`
	border-radius: 20px 20px 0 0;
	width: 100%;
	height: 228px;
	min-width: 100%;
	min-height: 200px;
	object-fit: cover;
	overflow: hidden;
`

export const CardDate = styled.div`
	font-weight: 500;
	font-size: 14px;
	margin-top: 10px;
	line-height: 120%;
	color: #696d6d;
	margin-bottom: 20px;
`
export const CardTitle = styled(Link)`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	cursor: pointer;
	font-size: 16px;
	line-height: 116%;
	letter-spacing: 0.02em;
	color: #202020;
	transition: color 0.3s ease;

	@media (max-width: 1024px) {
		font-size: 14px;
	}

	@media (max-width: 768px) {
		font-size: 16px;
	}

	&: hover {
		color: #01b75c;
	}
`

export const CardDescription = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: 116%;
	color: #8f8f8f;
	display: -webkit-box;
	-webkit-line-clamp: 2; /* Ограничивает текст двумя строками */
	-webkit-box-orient: vertical;
	overflow: hidden; /* Прячет все, что не поместилось */
	text-overflow: ellipsis; /* Добавляет троеточие в конце */

	/* Дополнительно (необязательно) */
	line-height: 1.4; /* Высота строки для красивого отображения */
	max-height: calc(1.4em * 2);
`

export const CardContent = styled.div`
	padding: 0 10px;
	flex-grow: 1;
	justify-content: space-between;
`

export const NewsPageHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-top: 20px;
`

export const FiltersContainer = styled.div<{ isMobile?: boolean }>`
	display: ${({ isMobile }) => (isMobile ? 'block' : 'flex')};
	gap: 15px;
	max-width: 100%;
	min-height: 55px;

	@media (max-width: 1024px) {
		gap: 5px;
	}
	@media (max-width: 630px) {
		align-self: end;
		min-height: 30px;
	}
`

export const NoNewsMessage = styled.div<{ isFiltersOpen?: boolean }>`
    display: ${({ isFiltersOpen }) => (isFiltersOpen ? 'none' : 'flex')};
    justify-content: center;
    align-items: center;
    height: 50vh;
    font-family: "e-Ukraine", sans-serif;
    font-weight: 300;
    font-size: 20px;
    color: #383838;
    
    @media(max-width: 430px) {
        font-size: 13px; 
    }
}
`

export const OpenFiltersBtn = styled.button`
	border: 1px solid #d9d9d9;
	border-radius: 17px;
	padding: 8px 13px;
	cursor: pointer;
	max-width: 230px;
	background: #fff;
	display: flex;
	align-items: center;
	gap: 10px;
	margin-left: auto;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 11px;
	line-height: 122%;
	letter-spacing: 0.01em;
	color: #484848;
	margin-top: 20px;

	img {
		width: 20px;
	}
`
export const FiltersCountNumber = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 13px;
	line-height: 122%;
	letter-spacing: 0.01em;
	color: #01924f;
`

export const TrailingArrow = styled(IoIosArrowRoundDown)<{
	$dir?: 'down' | 'up'
}>`
	margin-left: auto;
	flex: 0 0 auto;
	font-size: 24px;
	opacity: 0.8;
	transform: rotate(${p => (p.$dir === 'up' ? '180deg' : '0deg')});
`
